module.exports = __webpack_public_path__ + "static/media/Open.b70e36d5.svg";